import actions from '../../../constants/actionTypes';

const initialState = {
  bankAccount: {},
  balance: 0,
  bankTransfer: {},
  bankOptions: [],
  bankMapping: {},
};

function withdrawNowPortal(state = initialState, action) {
  const { /* response, */ type } = action;
  switch (type) {
    case actions.RECEIVE_BANK_ACCOUNT_NOW_PORTAL: {
      const { bankAccount } = action.response;
      return {
        ...state,
        bankAccount,
      };
    }
    case actions.RECEIVE_BALANCE_NOW_PORTAL: {
      const { balance } = action.response;
      return {
        ...state,
        balance,
      };
    }
    case actions.RECEIVE_BANK_TRANSFER_NOW_PORTAL: {
      const { bankTransfer } = action.response;
      return {
        ...state,
        bankTransfer,
      };
    }
    case actions.RECEIVE_LIST_BANK_NOW_PORTAL: {
      const { banks } = action.response;
      return {
        ...state,
        bankOptions: banks.map(bank => ({
          value: bank.id,
          label: bank.common_name,
        })),
        bankMapping: banks.reduce(
          (result, bank) => ({
            ...result,
            [bank.id]: bank,
          }),
          {},
        ),
      };
    }
    default:
      return state;
  }
}

export default withdrawNowPortal;



// WEBPACK FOOTER //
// ./foody/src/pages/NowPortal/NowPortalWithdraw/reducers.js